import { Controller } from "@hotwired/stimulus"

// Controller pour les boutons de montant rapide
// Remplit automatiquement le champ amount quand on clique sur un bouton
export default class extends Controller {
  select(event) {
    const amount = event.currentTarget.dataset.quickAmountValue
    const amountInput = this.element.parentElement.querySelector('input[name="amount"]')
    
    if (amountInput) {
      amountInput.value = amount
      amountInput.focus()
    }
  }
}
